import React, { createContext, useState, useRef, useEffect } from 'react';

export const ChatbotContext = createContext();

export const ChatbotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello! I'm here to help you with questions about Virtual IP's AI, web, and cybersecurity solutions. How can I assist you today?",
      sender: 'bot',
      timestamp: new Date(),
    },
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const sendMessageToBackend = async (message) => {
    try {
      const response = await fetch('http://localhost:5000/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      return data.response;
    } catch (error) {
      console.error('Error sending message to backend:', error);
      return "Sorry, I'm having trouble connecting. Please try again later.";
    }
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === '' || isLoading) return;

    const userMessage = {
      id: Date.now(),
      text: inputMessage.trim(),
      sender: 'user',
      timestamp: new Date(),
    };

    setMessages((prev) => [...prev, userMessage]);
    setInputMessage('');
    setIsTyping(true);
    setIsLoading(true);

    try {
      const botResponseText = await sendMessageToBackend(userMessage.text);

      setTimeout(() => {
        const botMessage = {
          id: Date.now() + 1,
          text: botResponseText,
          sender: 'bot',
          timestamp: new Date(),
        };
        setMessages((prev) => [...prev, botMessage]);
        setIsTyping(false);
        setIsLoading(false);
      }, 800);
    } catch {
      setTimeout(() => {
        const fallbackMessage = {
          id: Date.now() + 1,
          text: "I’m experiencing issues. Please try again or contact us directly.",
          sender: 'bot',
          timestamp: new Date(),
        };
        setMessages((prev) => [...prev, fallbackMessage]);
        setIsTyping(false);
        setIsLoading(false);
      }, 800);
    }
  };

  return (
    <ChatbotContext.Provider
      value={{
        isOpen,
        setIsOpen,
        messages,
        setMessages,
        inputMessage,
        setInputMessage,
        isTyping,
        setIsTyping,       // ✅ FIXED: added this
        isLoading,
        setIsLoading,      // ✅ FIXED: added this
        handleSendMessage,
        messagesEndRef,
      }}
    >
      {children}
    </ChatbotContext.Provider>
  );
};
